import { Input, Output, EventEmitter, ContentChild, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { NotImplementedViewModel } from "../../ui-ndms/view-models/not-implemented.view-model";
import { HasFormComponent } from "./hasFormComponent";
import { SearchModalComponent } from "../../ui-ndms/components/modals/search-modal/search-modal.component";

export class HasSearchModalComponent extends HasFormComponent<NotImplementedViewModel> {
    @Input() searchControl: FormControl;
    @Input() showButton: boolean = true;
    
    @ViewChild(SearchModalComponent) searchModal: SearchModalComponent;

    open() {
        this.searchModal.openModal();
    }

    onSelected(selectedResult: any) {
        this.searchControl.setValue(selectedResult);
    }

    mapModelToForm(formValue: any) {
        throw new Error("Method not implemented.");
    }
    mapFormToModel(model: any) {
        throw new Error("Method not implemented.");
    }
    resetForm(): void {
        throw new Error("Method not implemented.");
    }
}